export default __webpack_public_path__ + "static/media/folder-open-on.2e7ad118.svg";